import { createContext, useContext } from 'react';

import { PRESENCE_STATES } from 'lib/common/constants/presenceStates';

type PresenceContextType = {
  connectState: string | null;
  setConnectPresence: (presence: PRESENCE_STATES) => Promise<void>;
  isBusyFromConnect: boolean;
  visibleAgentPresence: PRESENCE_STATES;
  agentStates: connect.AgentStateDefinition[];
  agentNextState?: connect.AgentState;
  onContact: 'OnCall' | 'OnContact' | null;
};

const Context = createContext<PresenceContextType>({
  setConnectPresence: () => Promise.resolve(),
  visibleAgentPresence: PRESENCE_STATES.OFFLINE,
  connectState: null,
  isBusyFromConnect: false,
  agentStates: [],
  agentNextState: undefined,
  onContact: null,
});

export default Context;

// export the context hook
export const usePresenceContext = () => useContext(Context);
